import React, {useEffect, useState} from 'react';
import Link from 'next/link';
import {getItemActivities, ItemActivitiesInterface} from '@api/item';
import {useRouter} from 'next/router';
import {TextEllipsis} from 'neka-simple-utilities';
import {ethers} from 'ethers';
import {de} from 'date-fns/locale';

const activitiesList: Array<string> = ['All', 'Sales', 'Listing', 'Transfer', 'Bids', 'Mint'];
const columnList: Array<string> = ['Event', 'Price', 'From', 'To', 'Date'];

const Activity_tab = () => {
  const router = useRouter();
  const id = router.query.id;
  const [allActivitiesData, setAllActivitiesData] = useState<any>();
  const [listingData, setListingData] = useState<ItemActivitiesInterface[]>();
  const [bidData, setBidData] = useState<ItemActivitiesInterface[]>();
  const [mintData, setMintData] = useState<ItemActivitiesInterface[]>();
  const [saleData, setSaleData] = useState<ItemActivitiesInterface[]>();
  const [transferData, setTransferData] = useState<ItemActivitiesInterface[]>();
  const [isActive, setIsActive] = useState<number>(0);

  const getItemActivitiesData = async () => {
    const events = allActivitiesData?.find((e: any) => {
      return e.event;
    });
    const data = await getItemActivities({
      itemId: Number(id),
      page: 1,
      event: events,
    });

    setAllActivitiesData(data.records);
    return data;
  };

  const getListingData = async () => {
    const data = await getItemActivities({
      itemId: Number(id),
      page: 1,
      event: 'listing',
    });

    setListingData(data.records);
    return data;
  };

  const getBidData = async () => {
    const data = await getItemActivities({
      itemId: Number(id),
      page: 1,
      event: 'bid',
    });

    setBidData(data.records);
    return data;
  };

  const getMintData = async () => {
    const data = await getItemActivities({
      itemId: Number(id),
      page: 1,
      event: 'mint',
    });

    setMintData(data.records);
    return data;
  };

  const getTransferData = async () => {
    const data = await getItemActivities({
      itemId: Number(id),
      page: 1,
      event: 'transfer',
    });

    setTransferData(data.records);
    return data;
  };

  const getSaleData = async () => {
    const data = await getItemActivities({
      itemId: Number(id),
      page: 1,
      event: 'sale',
    });

    setSaleData(data.records);
    return data;
  };

  const Price = (price: string, decimal: number, currency: string) => {
    if (currency === '-' && price === '0') {
      return '-';
    }
    const priceInEther = ethers.utils.formatUnits(price, decimal);

    if (parseFloat(priceInEther) > 1) {
      return `${priceInEther.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${currency}`;
    } else {
      return `${priceInEther} ${currency}`;
    }
  };

  useEffect(() => {
    getItemActivitiesData();
    getListingData();
    getBidData();
    getMintData();
    getSaleData();
    getTransferData();
  }, []);

  return (
    <>
      {/* <!-- Activity --> */}
      <div className="tab-pane fade" id="activity" role="tabpanel" aria-labelledby="activity-tab">
        <div className="p-2 dark:bg-black-green-2 bg-white border border-b-0 rounded-large dark:border-dark-navy border-light-grey">
          <div className="px-4 pt-5 pb-2.5">
            <div className="flex flex-wrap">
              {activitiesList.map((activity, id) => {
                return (
                  <div key={id}>
                    {isActive == id ? (
                      <button className="dark:border-green-3 dark:bg-green-3 group dark:hover:bg-green-3 hover:bg-green-3 border-light-grey mr-2.5 mb-2.5 inline-flex items-center rounded-xl border bg-green-3 px-4 py-3 hover:border-transparent hover:text-white dark:text-light-grey text-dark-navy dark:hover:border-transparent">
                        <span className="text-2xs font-medium">{activity}</span>
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          setIsActive(id);
                        }}
                        className="dark:border-dark-grey dark:bg-grey group dark:hover:bg-green-3 hover:bg-green-3 border-light-grey mr-2.5 mb-2.5 inline-flex items-center rounded-xl border bg-grey px-4 py-3 hover:border-transparent hover:text-white dark:text-light-grey text-dark-navy dark:hover:border-transparent"
                      >
                        <span className="text-2xs font-medium">{activity}</span>
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          <div
            role="table"
            className="scrollbar-custom dark:bg-black-green-2 max-h-72 w-full overflow-y-auto rounded-none bg-white text-sm dark:text-white"
          >
            <div className="sticky top-0 flex" role="row">
              {columnList.map((column, id) => {
                return (
                  <div
                    key={id}
                    className="w-[25%] min-w-[100px] dark:bg-black-green bg-light-grey py-2 px-4"
                    role="columnheader"
                  >
                    <span className="text-dark-navy dark:text-white w-full overflow-hidden text-ellipsis">
                      {column}
                    </span>
                  </div>
                );
              })}
            </div>
            {/* all activties */}
            {allActivitiesData && isActive == 0 && (
              <>
                {allActivitiesData?.map((item: ItemActivitiesInterface, index: number) => {
                  return (
                    <div className="flex" role="row" key={index}>
                      <div
                        className="flex w-[25%] min-w-[100px] border-light-grey dark:border-black-green items-center border-t py-4 px-4 dark:text-white text-dark-navy"
                        role="cell"
                      >
                        {item.event}
                      </div>
                      <div
                        className="flex w-[25%] min-w-[100px] border-light-grey dark:border-black-green items-center whitespace-nowrap border-t py-4 px-4"
                        role="cell"
                      >
                        <span data-tippy-content="ETH">
                          <svg className="icon mr-1 h-4 w-4">
                            <use xlinkHref="icons.svg#icon-ETH"></use>
                          </svg>
                        </span>
                        {item.price == '-' ? (
                          <span className="dark:text-white text-dark-navy text-sm font-medium tracking-tight">
                            -
                          </span>
                        ) : (
                          <span className="dark:text-white text-dark-navy text-sm font-medium tracking-tight">
                            {Price(item.price, item.currencydecimals, item.currency)}
                          </span>
                        )}
                      </div>
                      <div
                        className="flex w-[25%] min-w-[100px] border-light-grey dark:border-black-green items-center border-t py-4 px-4"
                        role="cell"
                      >
                        {item.from.wallet_address !==
                        '0x0000000000000000000000000000000000000000' ? (
                          <>
                            {!item.from.username ? (
                              <Link href={`/user/${item.from.wallet_address}`}>
                                <a className="dark:text-white text-dark-navy">
                                  {TextEllipsis({
                                    text: item.from.wallet_address,
                                    position: 'middle',
                                    length: 4,
                                  })}
                                </a>
                              </Link>
                            ) : (
                              <Link href={`/user/${item.from.wallet_address}`}>
                                <a className="dark:text-white text-dark-navy">
                                  {item.from.username}
                                </a>
                              </Link>
                            )}
                          </>
                        ) : (
                          <a className="dark:text-white text-dark-navy">
                            {TextEllipsis({
                              text: item.from.wallet_address,
                              position: 'middle',
                              length: 4,
                            })}
                          </a>
                        )}
                      </div>
                      <div
                        className="flex w-[25%] min-w-[100px] border-light-grey dark:border-black-green items-center border-t py-4 px-4"
                        role="cell"
                      >
                        {!item.to.username ? (
                          <>
                            {item.to.wallet_address == '-' ? (
                              <a className="dark:text-white text-dark-navy">
                                {TextEllipsis({
                                  text: item.to.wallet_address,
                                  position: 'middle',
                                  length: 4,
                                })}
                              </a>
                            ) : (
                              <Link href={`/user/${item.to.wallet_address}`}>
                                <a className="dark:text-white text-dark-navy">
                                  {TextEllipsis({
                                    text: item.to.wallet_address,
                                    position: 'middle',
                                    length: 4,
                                  })}
                                </a>
                              </Link>
                            )}
                          </>
                        ) : (
                          <Link href={`/user/${item.to.wallet_address}`}>
                            <a className="dark:text-white text-dark-navy">{item.to.username}</a>
                          </Link>
                        )}
                      </div>
                      <div
                        className="flex w-[25%] min-w-[100px] border-light-grey dark:border-black-green items-center border-t py-4 px-4"
                        role="cell"
                      >
                        <Link href="#">
                          <a
                            className="dark:text-white text-dark-navy flex items-center"
                            target="_blank"
                            rel="nofollow noopener"
                            title="Opens in a new window"
                          >
                            <span className="mr-1 whitespace-nowrap text-ellipsis">{`${item.date}`}</span>
                          </a>
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </>
            )}

            {/* listing */}
            {listingData && isActive == 2 && (
              <>
                {listingData?.map((item: any, index: number) => {
                  return (
                    <div className="flex" role="row" key={index}>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4 dark:text-white text-dark-navy"
                        role="cell"
                      >
                        {item.event}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center whitespace-nowrap border-t py-4"
                        role="cell"
                      >
                        <span className="-ml-1" data-tippy-content="ETH">
                          <svg className="icon mr-1 h-4 w-4">
                            <use xlinkHref="icons.svg#icon-ETH"></use>
                          </svg>
                        </span>
                        {item.price == '-' ? (
                          <span className="dark:text-white text-dark-navy text-sm font-medium tracking-tight">
                            -
                          </span>
                        ) : (
                          <span className="dark:text-white text-dark-navy text-sm font-medium tracking-tight">
                            {Price(item.price, item.currencydecimals, item.currency)}
                          </span>
                        )}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4"
                        role="cell"
                      >
                        {!item.from.username ? (
                          <Link href={`/user/${item.from.wallet_address}`}>
                            <a className="dark:text-white text-dark-navy">
                              {TextEllipsis({
                                text: item.from.wallet_address,
                                position: 'middle',
                                length: 4,
                              })}
                            </a>
                          </Link>
                        ) : (
                          <Link href={`/user/${item.from.wallet_address}`}>
                            <a className="dark:text-white text-dark-navy">{item.from.username}</a>
                          </Link>
                        )}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4"
                        role="cell"
                      >
                        {!item.to.username ? (
                          <>
                            {item.to.wallet_address == '-' ? (
                              <a className="dark:text-white text-dark-navy">
                                {TextEllipsis({
                                  text: item.to.wallet_address,
                                  position: 'middle',
                                  length: 4,
                                })}
                              </a>
                            ) : (
                              <Link href={`/user/${item.to.wallet_address}`}>
                                <a className="dark:text-white text-dark-navy">
                                  {TextEllipsis({
                                    text: item.to.wallet_address,
                                    position: 'middle',
                                    length: 4,
                                  })}
                                </a>
                              </Link>
                            )}
                          </>
                        ) : (
                          <Link href={`/user/${item.to.wallet_address}`}>
                            <a className="dark:text-white text-dark-navy">{item.to.username}</a>
                          </Link>
                        )}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4"
                        role="cell"
                      >
                        <Link href="#">
                          <a
                            className="dark:text-white text-dark-navy flex items-center"
                            target="_blank"
                            rel="nofollow noopener"
                            title="Opens in a new window"
                          >
                            <span className="mr-1 whitespace-nowrap">{`${item.date}`}</span>
                          </a>
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </>
            )}

            {/* bid */}
            {bidData && isActive == 4 && (
              <>
                {bidData?.map((item: any, index: number) => {
                  return (
                    <div className="flex" role="row" key={index}>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4 dark:text-white text-dark-navy"
                        role="cell"
                      >
                        {item.event}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center whitespace-nowrap border-t py-4"
                        role="cell"
                      >
                        <span className="-ml-1" data-tippy-content="ETH">
                          <svg className="icon mr-1 h-4 w-4">
                            <use xlinkHref="icons.svg#icon-ETH"></use>
                          </svg>
                        </span>
                        {item.price == '-' ? (
                          <span className="dark:text-white text-dark-navy text-sm font-medium tracking-tight">
                            -
                          </span>
                        ) : (
                          <span className="dark:text-white text-dark-navy text-sm font-medium tracking-tight">
                            {Price(item.price, item.currencydecimals, item.currency)}
                          </span>
                        )}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4"
                        role="cell"
                      >
                        {!item.from.username ? (
                          <Link href={`/user/${item.from.wallet_address}`}>
                            <a className="dark:text-white text-dark-navy">
                              {TextEllipsis({
                                text: item.from.wallet_address,
                                position: 'middle',
                                length: 4,
                              })}
                            </a>
                          </Link>
                        ) : (
                          <Link href={`/user/${item.from.wallet_address}`}>
                            <a className="dark:text-white text-dark-navy">{item.from.username}</a>
                          </Link>
                        )}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4"
                        role="cell"
                      >
                        {!item.to.username ? (
                          <Link href={`/user/${item.to.wallet_address}`}>
                            <a className="dark:text-white text-dark-navy">
                              {TextEllipsis({
                                text: item.to.wallet_address,
                                position: 'middle',
                                length: 4,
                              })}
                            </a>
                          </Link>
                        ) : (
                          <Link href={`/user/${item.to.wallet_address}`}>
                            <a className="dark:text-white text-dark-navy">{item.to.username}</a>
                          </Link>
                        )}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4"
                        role="cell"
                      >
                        <Link href="#">
                          <a
                            className="dark:text-white text-dark-navy flex items-center"
                            target="_blank"
                            rel="nofollow noopener"
                            title="Opens in a new window"
                          >
                            <span className="mr-1 whitespace-nowrap">{`${item.date}`}</span>
                          </a>
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </>
            )}

            {/* mint */}
            {mintData && isActive == 5 && (
              <>
                {mintData?.map((item: any, index: number) => {
                  return (
                    <div className="flex" role="row" key={index}>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4 dark:text-white text-dark-navy"
                        role="cell"
                      >
                        {item.event}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center whitespace-nowrap border-t py-4"
                        role="cell"
                      >
                        <span className="-ml-1" data-tippy-content="ETH">
                          <svg className="icon mr-1 h-4 w-4">
                            <use xlinkHref="icons.svg#icon-ETH"></use>
                          </svg>
                        </span>
                        {item.price == '-' ? (
                          <span className="dark:text-white text-dark-navy text-sm font-medium tracking-tight">
                            -
                          </span>
                        ) : (
                          <span className="dark:text-white text-dark-navy text-sm font-medium tracking-tight">
                            {Price(item.price, item.currencydecimals, item.currency)}
                          </span>
                        )}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4"
                        role="cell"
                      >
                        {item.from.wallet_address !==
                        '0x0000000000000000000000000000000000000000' ? (
                          <>
                            {!item.from.username ? (
                              <Link href={`/user/${item.from.wallet_address}`}>
                                <a className="dark:text-white text-dark-navy">
                                  {TextEllipsis({
                                    text: item.from.wallet_address,
                                    position: 'middle',
                                    length: 4,
                                  })}
                                </a>
                              </Link>
                            ) : (
                              <Link href={`/user/${item.from.wallet_address}`}>
                                <a className="dark:text-white text-dark-navy">
                                  {item.from.username}
                                </a>
                              </Link>
                            )}
                          </>
                        ) : (
                          <a className="dark:text-white text-dark-navy">
                            {TextEllipsis({
                              text: item.from.wallet_address,
                              position: 'middle',
                              length: 4,
                            })}
                          </a>
                        )}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4"
                        role="cell"
                      >
                        {!item.to.username ? (
                          <Link href={`/user/${item.to.wallet_address}`}>
                            <a className="dark:text-white text-dark-navy">
                              {TextEllipsis({
                                text: item.to.wallet_address,
                                position: 'middle',
                                length: 4,
                              })}
                            </a>
                          </Link>
                        ) : (
                          <Link href={`/user/${item.to.wallet_address}`}>
                            <a className="dark:text-white text-dark-navy">{item.to.username}</a>
                          </Link>
                        )}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4"
                        role="cell"
                      >
                        <Link href="#">
                          <a
                            className="dark:text-white text-dark-navy flex items-center"
                            target="_blank"
                            rel="nofollow noopener"
                            title="Opens in a new window"
                          >
                            <span className="mr-1 whitespace-nowrap">{`${item.date}`}</span>
                          </a>
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </>
            )}

            {/* transfer */}
            {transferData && isActive == 3 && (
              <>
                {transferData?.map((item: any, index: number) => {
                  return (
                    <div className="flex" role="row" key={index}>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4 dark:text-white text-dark-navy"
                        role="cell"
                      >
                        {item.event}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center whitespace-nowrap border-t py-4"
                        role="cell"
                      >
                        <span className="-ml-1" data-tippy-content="ETH">
                          <svg className="icon mr-1 h-4 w-4">
                            <use xlinkHref="icons.svg#icon-ETH"></use>
                          </svg>
                        </span>
                        {item.price == '-' ? (
                          <span className="dark:text-white text-dark-navy text-sm font-medium tracking-tight">
                            -
                          </span>
                        ) : (
                          <span className="dark:text-white text-dark-navy text-sm font-medium tracking-tight">
                            {Price(item.price, item.currencydecimals, item.currency)}
                          </span>
                        )}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4"
                        role="cell"
                      >
                        {!item.from.username ? (
                          <Link href={`/user/${item.from.wallet_address}`}>
                            <a className="dark:text-white text-dark-navy">
                              {TextEllipsis({
                                text: item.from.wallet_address,
                                position: 'middle',
                                length: 4,
                              })}
                            </a>
                          </Link>
                        ) : (
                          <Link href={`/user/${item.from.wallet_address}`}>
                            <a className="dark:text-white text-dark-navy">{item.from.username}</a>
                          </Link>
                        )}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4"
                        role="cell"
                      >
                        {!item.to.username ? (
                          <Link href={`/user/${item.to.wallet_address}`}>
                            <a className="dark:text-white text-dark-navy">
                              {TextEllipsis({
                                text: item.to.wallet_address,
                                position: 'middle',
                                length: 4,
                              })}
                            </a>
                          </Link>
                        ) : (
                          <Link href={`/user/${item.to.wallet_address}`}>
                            <a className="dark:text-white text-dark-navy">{item.to.username}</a>
                          </Link>
                        )}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4"
                        role="cell"
                      >
                        <Link href="#">
                          <a
                            className="dark:text-white text-dark-navy flex items-center"
                            target="_blank"
                            rel="nofollow noopener"
                            title="Opens in a new window"
                          >
                            <span className="mr-1 whitespace-nowrap">{`${item.date}`}</span>
                          </a>
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </>
            )}

            {/* sale */}
            {saleData && isActive == 1 && (
              <>
                {saleData?.map((item: any, index: number) => {
                  return (
                    <div className="flex" role="row" key={index}>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4 dark:text-white text-dark-navy"
                        role="cell"
                      >
                        {item.event}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center whitespace-nowrap border-t py-4"
                        role="cell"
                      >
                        <span className="-ml-1" data-tippy-content="ETH">
                          <svg className="icon mr-1 h-4 w-4">
                            <use xlinkHref="icons.svg#icon-ETH"></use>
                          </svg>
                        </span>
                        {item.price == '-' ? (
                          <span className="dark:text-white text-dark-navy text-sm font-medium tracking-tight">
                            -
                          </span>
                        ) : (
                          <span className="dark:text-white text-dark-navy text-sm font-medium tracking-tight">
                            {Price(item.price, item.currencydecimals, item.currency)}
                          </span>
                        )}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4"
                        role="cell"
                      >
                        {!item.from.username ? (
                          <Link href={`/user/${item.from.wallet_address}`}>
                            <a className="dark:text-white text-dark-navy">
                              {TextEllipsis({
                                text: item.from.wallet_address,
                                position: 'middle',
                                length: 4,
                              })}
                            </a>
                          </Link>
                        ) : (
                          <Link href={`/user/${item.from.wallet_address}`}>
                            <a className="dark:text-white text-dark-navy">{item.from.username}</a>
                          </Link>
                        )}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4"
                        role="cell"
                      >
                        {!item.to.username ? (
                          <Link href={`/user/${item.to.wallet_address}`}>
                            <a className="dark:text-white text-dark-navy">
                              {TextEllipsis({
                                text: item.to.wallet_address,
                                position: 'middle',
                                length: 4,
                              })}
                            </a>
                          </Link>
                        ) : (
                          <Link href={`/user/${item.to.wallet_address}`}>
                            <a className="dark:text-white text-dark-navy">{item.to.username}</a>
                          </Link>
                        )}
                      </div>
                      <div
                        className="flex w-[25%] border-light-grey dark:border-black-green items-center border-t py-4 px-4"
                        role="cell"
                      >
                        <Link href="#">
                          <a
                            className="dark:text-white text-dark-navy flex items-center"
                            target="_blank"
                            rel="nofollow noopener"
                            title="Opens in a new window"
                          >
                            <span className="mr-1 whitespace-nowrap">{`${item.date}`}</span>
                          </a>
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Activity_tab;
